import script from "./UserAvatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserAvatar.vue?vue&type=script&lang=ts&setup=true"

import "./UserAvatar.vue?vue&type=style&index=0&id=d8bc2ab4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8bc2ab4"]])

export default __exports__